import { render, staticRenderFns } from "./Kardex.vue?vue&type=template&id=fec22a8c&scoped=true&"
import script from "./Kardex.vue?vue&type=script&lang=js&"
export * from "./Kardex.vue?vue&type=script&lang=js&"
import style0 from "./Kardex.vue?vue&type=style&index=0&id=fec22a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec22a8c",
  null
  
)

export default component.exports